document.addEventListener('DOMContentLoaded', () => {
  // Global functions to open/close
  window.openQubeCartDrawer = function() {
    const drawer = document.getElementById('qube-cart-drawer');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      updateQubeCart(); // Refresh cart data on open
    }
  };

  window.closeQubeCartDrawer = function() {
    const drawer = document.getElementById('qube-cart-drawer');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
    }
  };

  // Format money helper
  function formatMoney(cents) {
    return window.QubeCartSettings.currencySymbol + (cents / 100).toFixed(2);
  }

  // Update Free Shipping Bar
  function updateShippingBar(totalPrice) {
    const threshold = window.QubeCartSettings.freeShippingThreshold;
    const progressText = document.getElementById('qube-shipping-text');
    const progressBar = document.getElementById('qube-shipping-progress-bar');
    
    if (!progressText || !progressBar) return;

    if (totalPrice >= threshold) {
      progressText.innerHTML = 'You have unlocked <strong>Free Shipping!</strong>';
      progressBar.style.width = '100%';
    } else {
      const remaining = threshold - totalPrice;
      progressText.innerHTML = `You are <strong>${formatMoney(remaining)}</strong> away from Free Shipping!`;
      const percentage = (totalPrice / threshold) * 100;
      progressBar.style.width = percentage + '%';
    }
  }

  // Build Cart Item HTML
  function buildCartItemHTML(item) {
    const isFreeGift = window.QubeCartSettings.freeGiftVariantId && item.variant_id === window.QubeCartSettings.freeGiftVariantId;
    
    return `
      <div class="qube-cart-item${isFreeGift ? ' qube-cart-item--free-gift' : ''}" data-key="${item.key}">
        <div class="qube-cart-item__image-wrap">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" class="qube-cart-item__image">` : ''}
        </div>
        <div class="qube-cart-item__info">
          <div class="qube-cart-item__header">
            <div class="qube-cart-item__title-wrap">
              <a href="${item.url}" class="qube-cart-item__title">${item.product_title}</a>
              ${item.variant_title ? `<p class="qube-cart-item__variant">${item.variant_title}</p>` : ''}
              ${isFreeGift ? '<p class="qube-cart-item__free-badge">🎁 FREE GIFT</p>' : ''}
            </div>
            ${!isFreeGift ? `
            <button class="qube-cart-item__remove" onclick="changeQubeCartItem('${item.key}', 0)" aria-label="Remove item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>` : ''}
          </div>
          
          <div class="qube-cart-item__price-row">
            ${!isFreeGift ? `
            <div class="qube-cart-item__qty-pill">
              <button class="qube-cart-item__qty-btn" onclick="changeQubeCartItem('${item.key}', ${item.quantity - 1})">-</button>
              <input type="number" class="qube-cart-item__qty-input" value="${item.quantity}" readonly>
              <button class="qube-cart-item__qty-btn" onclick="changeQubeCartItem('${item.key}', ${item.quantity + 1})">+</button>
              </div>` : `<div class="qube-cart-item__qty-pill"><span style="padding: 0 12px; font-size: 13px;">Qty: ${item.quantity}</span></div>`}

            
              <div class="qube-cart-item__price-wrap">
              ${isFreeGift ? `
                <s class="qube-cart-item__original-price">${formatMoney(item.original_line_price)}</s>
                <span class="qube-cart-item__price">${formatMoney(0)}</span>
              ` : `
                ${item.original_line_price > item.final_line_price ? `<s class="qube-cart-item__original-price">${formatMoney(item.original_line_price)}</s>` : ''}
                <span class="qube-cart-item__price">${formatMoney(item.final_line_price)}</span>
              `}
            </div>

          </div>
        </div>
      </div>
    `;
  }

  // --- Free Gift Logic (self-contained, no pubsub) ---
  let isCheckingFreeGift = false;

  function ensureFreeGift(cart) {
    const freeVariantId = window.QubeCartSettings.freeGiftVariantId;
    if (!freeVariantId) return Promise.resolve(false);

    let totalItems = 0;
    let freeGiftInCart = false;
    let freeGiftKey = null;
    let freeGiftQty = 0;

    cart.items.forEach(item => {
      if (item.variant_id === freeVariantId) {
        freeGiftInCart = true;
        freeGiftKey = item.key;
        freeGiftQty = item.quantity;
      } else {
        totalItems += item.quantity;
      }
    });

    let updates = {};
    let needsUpdate = false;

        if (totalItems > 0 && !freeGiftInCart) {
      // Cart has items but no free gift — add it
      updates[freeVariantId] = totalItems;
      needsUpdate = true;
    } else if (totalItems === 0 && freeGiftInCart) {
      // Cart is empty except for the free gift — remove it
      updates[freeGiftKey] = 0;
      needsUpdate = true;
    } else if (freeGiftInCart && freeGiftQty !== totalItems && totalItems > 0) {
      // Free gift quantity should match total main items
      updates[freeGiftKey] = totalItems;
      needsUpdate = true;
    }


    if (needsUpdate) {
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
      .then(() => true)
      .catch(() => false);
    }

    return Promise.resolve(false);
  }

  // Render cart from data (shared render logic)
  function renderCart(cart) {
    const container = document.getElementById('qube-cart-items-container');
    const subtotalEl = document.getElementById('qube-cart-subtotal');
    const countEl = document.getElementById('qube-cart-count');
    const footerEl = document.getElementById('qube-drawer-footer');
    const shippingEl = document.getElementById('qube-shipping-bar-container');

    if (countEl) countEl.innerText = cart.item_count;

    const bubbleCount = document.getElementById('qube-header-cart-count');
    if (bubbleCount) {
      bubbleCount.innerText = cart.item_count;
      bubbleCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    const freeVariantId = window.QubeCartSettings.freeGiftVariantId;
    let nonGiftSubtotal = 0;
    cart.items.forEach(item => {
      if (item.variant_id !== freeVariantId) {
        nonGiftSubtotal += item.final_line_price;
      }
    });

    if (subtotalEl) subtotalEl.innerText = formatMoney(nonGiftSubtotal);
    updateShippingBar(nonGiftSubtotal);

    if (cart.items.length === 0) {
      container.innerHTML = `
        <div class="qube-drawer__empty-state">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <path d="M16 10a4 4 0 0 1-8 0"></path>
          </svg>
          <h3 class="qube-drawer__empty-text">Your cart is currently empty.</h3>
          <button class="qube-drawer__checkout-btn" onclick="closeQubeCartDrawer()"><span>Continue Shopping</span></button>
        </div>
      `;
      if (footerEl) footerEl.style.display = 'none';
      if (shippingEl) shippingEl.style.display = 'none';
    } else {
      // Sort items so the free gift always appears at the bottom
      const freeVariantId = window.QubeCartSettings.freeGiftVariantId;
      const sortedItems = [...cart.items].sort((a, b) => {
        const aIsFree = freeVariantId && a.variant_id === freeVariantId;
        const bIsFree = freeVariantId && b.variant_id === freeVariantId;
        if (aIsFree && !bIsFree) return 1;
        if (!aIsFree && bIsFree) return -1;
        return 0;
      });
      container.innerHTML = sortedItems.map(buildCartItemHTML).join('');
      if (footerEl) footerEl.style.display = 'block';
      if (shippingEl) shippingEl.style.display = 'block';
    }
  }

  // Fetch and update cart HTML (with integrated free gift check)
  window.updateQubeCart = function() {
    const loadingState = document.getElementById('qube-drawer-loading');
    if (loadingState) loadingState.classList.remove('hidden');

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if we need to add/remove the free gift
        return ensureFreeGift(cart).then(cartWasModified => {
          if (cartWasModified) {
            // Cart was modified (free gift added/removed), re-fetch to get updated data
            return fetch(window.Shopify.routes.root + 'cart.js')
              .then(r => r.json())
              .then(updatedCart => {
                renderCart(updatedCart);
              });
          } else {
            // No changes needed, render as-is
            renderCart(cart);
          }
        });
      })
      .catch(error => console.error('Error fetching cart:', error))
      .finally(() => {
        if (loadingState) loadingState.classList.add('hidden');
      });
  };

  // Change quantity or remove item
  window.changeQubeCartItem = function(key, quantity) {
    const loadingState = document.getElementById('qube-drawer-loading');
    if (loadingState) loadingState.classList.remove('hidden');

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      updateQubeCart();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      if (loadingState) loadingState.classList.add('hidden');
    });
  };

});
